import Button from 'components/Button';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { colors, sizes, media } from 'styles/variables';

const StyledWrapper = styled.div`
	display: block;
	display: grid;
	${media.notsmall} {
		grid-template-columns: 2fr 1fr;
	}
	${media.small} {
		grid-auto-flow: rows;
	}
	grid-gap: ${sizes[2]};
	margin: ${sizes[2]} 0;
	input {
		background: none;
		outline: none;
		border: none;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
		padding: ${sizes[1]};
		text-align: center;
	}
	&.--dark {
		input {
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		}
	}
	.--inactive {
		pointer-events: none;
		filter: grayscale(1) brightness(1.5);
		opacity: 0.75;
	}
	&.--dark {
		.--inactive {
			filter: grayscale(1) brightness(0.5);
		}
	}
`;

export default props => {
	const [view, setView] = useState(1);
	const [active, setActive] = useState(false);
	const [email, setEmail] = useState('');

	useEffect(() => {
		if (typeof localStorage !== 'undefined' && localStorage.getItem('form')) {
			const form = JSON.parse(localStorage.getItem('form'));
			setEmail(form.values.email);
			if (validateEmail(form.values.email)) {
				setActive(true);
			} else {
				setActive(false);
			}
		}
	});

	const validateEmail = email => {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	const handleInput = e => {
		const v = e.target.value;
		setEmail(v);
		if (validateEmail(v)) {
			setActive(true);
		} else {
			setActive(false);
		}
	};

	const handleSubmit = e => {
		axios
			.post('/.netlify/functions/email_error', { data: { email: email, group: props.group } })
			.then(e => setView(2));
	};

	return (
		<>
			{view === 1 && (
				<StyledWrapper className={`--${props.theme}`}>
					<input
						type="email"
						placeholder="jsmith@gmail.com"
						defaultValue={email}
						onChange={e => handleInput(e)}
					/>
					<div className={active ? '--active' : '--inactive'} onClick={e => handleSubmit(e)}>
						<Button title="Subscribe" type={1} hue={props.theme === 'dark' ? 'teal' : 'pink'} />
					</div>
				</StyledWrapper>
			)}
			{view === 2 && <h2>You have successfully subscribed to Reshape updates.</h2>}
		</>
	);
};
